export default "__VITE_ASSET__CLonqmRp__";